import React from 'react';
import { MdClose, MdPerson, MdEmail, MdPhone, MdLocationOn, MdGroup, MdDateRange } from 'react-icons/md';

const ViewRevenueOfficerModal = ({ isOpen, onClose, officer }) => {
  if (!isOpen || !officer) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: 12,
        padding: 24,
        width: '90%',
        maxWidth: 600,
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 20,
          paddingBottom: 16,
          borderBottom: '1px solid #e0e0e0',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <MdPerson size={24} style={{ color: '#1976d2' }} />
            <h2 style={{ margin: 0, color: '#333', fontSize: 20 }}>Revenue Officer Details</h2>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 8,
              borderRadius: 4,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <MdClose size={24} style={{ color: '#666' }} />
          </button>
        </div>

        {/* Officer Profile Section */}
        <div style={{
          backgroundColor: '#f8f9fa',
          padding: 20,
          borderRadius: 8,
          marginBottom: 20,
          display: 'flex',
          alignItems: 'center',
          gap: 20,
        }}>
          <div style={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            backgroundColor: '#28a745',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <MdPerson size={40} style={{ color: 'white' }} />
          </div>
          <div style={{ flex: 1 }}>
            <h3 style={{ margin: '0 0 8px 0', color: '#333', fontSize: 22 }}>
              {officer.first_name} {officer.last_name}
            </h3>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
              <span style={{ 
                padding: '4px 12px',
                backgroundColor: '#e8f5e8',
                borderRadius: 16,
                fontSize: 12,
                fontWeight: 'bold',
                color: '#2e7d32'
              }}>
                REVENUE OFFICER
              </span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{
                padding: '4px 8px',
                backgroundColor: officer.status === 'active' ? '#e8f5e8' : '#ffebee',
                borderRadius: 4,
                fontSize: 12,
                fontWeight: 'bold',
                color: officer.status === 'active' ? '#2e7d32' : '#c62828'
              }}>
                {(officer.status || 'active').charAt(0).toUpperCase() + (officer.status || 'active').slice(1)}
              </span>
            </div>
          </div>
        </div>

        {/* Contact Information */}
        <div style={{
          backgroundColor: 'white',
          border: '1px solid #e0e0e0',
          borderRadius: 8,
          padding: 20,
          marginBottom: 20,
        }}>
          <h3 style={{ margin: '0 0 16px 0', color: '#333', fontSize: 16 }}>Contact Information</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdEmail size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Email Address</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>{officer.email}</p>
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdPhone size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Phone Number</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>{officer.phone}</p>
            </div>
          </div>
        </div>

        {/* Assignment Information */}
        <div style={{
          backgroundColor: 'white',
          border: '1px solid #e0e0e0',
          borderRadius: 8,
          padding: 20,
          marginBottom: 20,
        }}>
          <h3 style={{ margin: '0 0 16px 0', color: '#333', fontSize: 16 }}>Assignment Information</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdLocationOn size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Assigned Zone</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>{officer.zone_name || 'Not assigned'}</p>
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdGroup size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Group Assignment</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>{officer.group_name || 'Not assigned'}</p>
            </div>
          </div>
        </div>

        {/* Officer Information */}
        <div style={{
          backgroundColor: 'white',
          border: '1px solid #e0e0e0',
          borderRadius: 8,
          padding: 20,
          marginBottom: 20,
        }}>
          <h3 style={{ margin: '0 0 16px 0', color: '#333', fontSize: 16 }}>Officer Information</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdDateRange size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Date Assigned</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>
                {officer.assignment_date ? new Date(officer.assignment_date).toLocaleDateString() : 
                 officer.created_at ? new Date(officer.created_at).toLocaleDateString() : 'Unknown'}
              </p>
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <MdPerson size={16} style={{ color: '#666' }} />
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Officer ID</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#333' }}>{officer.officer_id}</p>
            </div>
          </div>
        </div>

        {/* Performance Summary */}
        <div style={{
          backgroundColor: '#e8f5e8',
          padding: 16,
          borderRadius: 8,
          marginBottom: 20,
          border: '1px solid #c8e6c9',
        }}>
          <h3 style={{ margin: '0 0 8px 0', color: '#2e7d32', fontSize: 14, fontWeight: 'bold' }}>
            Revenue Officer Status
          </h3>
          <p style={{ margin: 0, fontSize: 12, color: '#2e7d32' }}>
            This officer is authorized to collect revenue within their assigned zone. 
            Click the "Performance" button to view detailed collection metrics and analytics.
          </p>
        </div>

        {/* Close Button */}
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '10px 20px',
              border: 'none',
              borderRadius: 4,
              backgroundColor: '#1976d2',
              color: 'white',
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: 'bold',
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewRevenueOfficerModal;
